module.exports = __webpack_public_path__ + "img/10.f8daa68e.svg";